import { Box } from "@mui/material";
import { AreaLineChart } from "../../charts";
import { useStyles } from "./style";

interface SeriesData {
  data: number[];
  label: string;
}

interface ChartCardProps {
  title: string;
  series: SeriesData[];
  xLabels: string[];
}

export const ChartCard = ({ title, series, xLabels }: ChartCardProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.title}>{title}</Box>
      <AreaLineChart series={series} xLabels={xLabels} />
    </Box>
  );
};
